import { useEffect, useRef } from 'react';

/**
 * Calls `onAfterClose` once `ms` after `open` goes from true to false, e.g. when
 * a sheet has finished sliding away. Reopening within `ms` cancels it, and a
 * sheet that mounts closed never fires.
 */
export function useAfterClose(open: boolean, onAfterClose: (() => void) | undefined, ms: number) {
  const callbackRef = useRef(onAfterClose);
  callbackRef.current = onAfterClose;
  const wasOpen = useRef(open);

  useEffect(() => {
    if (open) {
      wasOpen.current = true;
      return;
    }
    if (!wasOpen.current) return;
    const id = window.setTimeout(() => {
      wasOpen.current = false;
      callbackRef.current?.();
    }, ms);
    return () => window.clearTimeout(id);
  }, [open, ms]);
}
